import { ButtonHTMLAttributes, FC } from 'react';

import { useGetSubscription } from 'modules/account/settings/hooks';
import { cn } from 'utils/helpers';

interface PROPS extends ButtonHTMLAttributes<HTMLButtonElement> {}

const IconButton: FC<PROPS> = ({ children, disabled, ...props }) => {
  const { data: subscription } = useGetSubscription();

  return (
    <button
      type="button"
      className={cn(
        'hover:text-primary-base text-content',
        'w-9 h-9 rounded-full',
        'bg-fill-primary',
        'flex items-center justify-center',
        'disabled:text-disabled',
      )}
      disabled={subscription?.isExpired || disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export default IconButton;
